import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Body = styled.div`
	padding: 24px 16px 24px 16px;
	display: flex;
	flex-direction: column;
	width: 100%;
	overflow: auto;
	height: 100%;
`;

export const Header = styled.div`
	text-align: center;
	width: 100%;
	padding: 16px 40px;
	border-bottom: 1px solid ${({ theme }) => theme.borders.border200};
`;

export const RegisterActionWrapper = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	text-align: center;
`;

export const Action = styled.button`
	cursor: pointer;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	color: ${({ theme }) => theme.colors.control.primary};
`;

export const Footer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const RulesWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	font-size: 14px;
	color: ${({ theme }) => theme.colors.text.body};
	margin-top: 20px;
`;
